// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"478":"6c1df8cc","498":"d096c73c","513":"9aa08293","546":"01a0c80d","703":"c3d30244","787":"c3525396"}[chunkId] + ".chunk.js";
};